export * from './fileHelpers';
export * from './fileUtils';

const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const storageUsagePercentage = (limit, max) => {
  const maxStorageBytes = 1073741824; // 1GB in bytes
  const currentUsage = Number.parseFloat(limit || 0);
  const percentage = (currentUsage / maxStorageBytes) * 100;
  // Round to 2 decimal places and ensure it doesn't exceed 100%
  return {
    percentage: Math.min(Number.parseFloat(percentage.toFixed(2)), 100),
    current: formatBytes(currentUsage),
    total: formatBytes(maxStorageBytes)
  };
};
